import cn from 'clsx'

import { ImageBox, NavLink } from 'shared-components'

import BlockArrow from '../../images/blockArrow'

import s from './FeatureProject.module.sass'

function FeatureProject({ project }: any) {
    const { title, slug, featuredImage, excerpt, projectCategories, client, quote } = project

    const _projectCategories = projectCategories
        ? projectCategories.map((category: any) => category?.name).join(', ')
        : null

    const _excerpt = excerpt?.length > 200 ? `${excerpt.substring(0, 200)}...` : excerpt

    return (
        <div className={s.FeatureProject}>
            <NavLink href={`/our-work/${slug?.current}`} className={s.Link}>
                <div className={s.Content}>
                    <div className={cn(s.Cont, 'container')}>
                        <div className={s.ContentInner}>
                            <div className={s.Main}>
                                {title && (
                                    <h1
                                        dangerouslySetInnerHTML={{
                                            __html: title,
                                        }}
                                    />
                                )}
                                {_excerpt && (
                                    <div
                                        className={cn(s.Excerpt, 'copy small')}
                                        dangerouslySetInnerHTML={{
                                            __html: _excerpt,
                                        }}
                                    />
                                )}
                                <div className={s.ProjectDetails}>
                                    {client && <span dangerouslySetInnerHTML={{ __html: client }} />}
                                    {_projectCategories && (
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: _projectCategories,
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className={s.Quote}>
                                {quote && (
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: quote,
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={s.Image}>{featuredImage && <ImageBox image={featuredImage} />}</div>
                <div className={s.ViewWork}>
                    <span>View work</span>
                    {BlockArrow}
                </div>
            </NavLink>
        </div>
    )
}

export default FeatureProject
